import { interpolateColor, useAnimatedStyle, useDerivedValue, withSpring } from 'react-native-reanimated';
import { useTheme } from 'styled-components/native';
import { springConfig } from '~/constants/animations';
import { PressableAnimationsProps } from '~/types/animations';

export interface MenuItemAnimationsRenderPropValue {
    backgroundColor: string;
}

export interface MenuItemAnimationsProps extends PressableAnimationsProps<MenuItemAnimationsRenderPropValue> {}

export const MenuItemBackgroundAnimation = ({ progress, children }: MenuItemAnimationsProps) => {
    const theme = useTheme();

    const backgroundProgress = useDerivedValue(() => withSpring(progress, springConfig.default));

    const currentBackground: Record<string, string> = {
        default: 'transparent',
        hovered: theme.palette.opacity['08'].rgba,
        pressed: theme.palette.opacity['08'].rgba,
    };

    const animatedStyle = useAnimatedStyle(() => {
        return {
            backgroundColor: interpolateColor(
                backgroundProgress.value,
                [0, 1, 2],
                [currentBackground.default, currentBackground.hovered, currentBackground.pressed],
            ),
        };
    }, []);

    return children(animatedStyle);
};
